import React from 'react';
import ModalQr from '../components/modal';
import styled from 'styled-components';

import SSN from '../assets/SSN.png';
import DataFiscal from '../assets/data-fiscal.jpg';


const Div = styled.div`

    color: #26384d;
    background: #ffffff;


    /* =================================
       INFORMACIÓN SSN
    ================================= */

    .legal-authority {
        max-width: 1200px;
        margin: 0 auto;

        display: grid;
        grid-template-columns: repeat(3, 1fr);

        border-top: 1px solid #e5e8eb;
        border-bottom: 1px solid #e5e8eb;
    }

    .legal-authority-item {
        min-height: 75px;

        display: flex;
        align-items: center;
        justify-content: center;

        text-align: center;

        padding: 15px 20px;
    }

    .legal-authority-item + .legal-authority-item {
        border-left: 1px solid #e5e8eb;
    }

    .legal-authority p {
        margin: 0;

        font-size: 12px;
        line-height: 1.4;

        color: #526274;
    }

    .legal-authority strong {
        display: block;

        margin-bottom: 3px;

        color: #26384d;
        font-weight: 600;
    }

    .legal-authority img {
        width: 190px;
        max-width: 100%;
    }


    /* =================================
       ATENCIÓN AL ASEGURADO
    ================================= */

    .insured-attention {
        max-width: 1100px;

        margin: 0 auto;

        padding: 55px 30px 50px;
    }

    .attention-header {
        margin-bottom: 30px;
    }

    .attention-header span {
        display: block;

        margin-bottom: 7px;

        color: #E85A20;

        font-size: 12px;
        font-weight: 700;

        letter-spacing: 2px;
        text-transform: uppercase;
    }

    .attention-header h3 {
        margin: 0;

        color: #102B50;

        font-size: 28px;
        font-weight: 700;
    }

    .attention-line {
        width: 40px;
        height: 3px;

        margin-top: 12px;

        background: #E85A20;

        border-radius: 5px;
    }


    /* =================================
       HORARIO
    ================================= */

    .attention-schedule {
        padding: 18px 22px;

        margin-bottom: 25px;

        background: #f6f8fa;

        border-left: 4px solid #E85A20;

        border-radius: 3px;
    }

    .attention-schedule p {
        margin: 0;

        font-size: 14px;
        line-height: 1.5;
    }


    /* =================================
       TEXTO LEGAL
    ================================= */

    .attention-description {
        margin-bottom: 30px;

        font-size: 13px;
        line-height: 1.7;

        color: #526274;
    }


    /* =================================
       RESPONSABLE / SUPLENTE
    ================================= */

    .attention-contacts {
        display: grid;
        grid-template-columns: repeat(2, 1fr);

        gap: 20px;

        margin-bottom: 25px;
    }

    .attention-contact {
        padding: 20px;

        background: #ffffff;

        border: 1px solid #e4e8ec;
        border-radius: 6px;
    }

    .attention-contact strong {
        display: block;

        margin-bottom: 8px;

        color: #102B50;

        font-size: 13px;
    }

    .attention-contact p {
        margin: 0;

        font-size: 13px;
        line-height: 1.6;

        color: #526274;
    }

    .attention-contact a,
    .attention-footer a {
        color: #E85A20;
        text-decoration: none;
    }

    .attention-contact a:hover,
    .attention-footer a:hover {
        text-decoration: underline;
    }


    /* =================================
       INSCRIPCIÓN / RECLAMOS
    ================================= */

    .attention-footer {
        padding-top: 5px;

        font-size: 13px;
        line-height: 1.7;

        color: #526274;
    }

    .attention-footer p {
        margin: 12px 0;
    }

    .attention-footer strong {
        color: #26384d;
    }


    /* =================================
       COPYRIGHT
    ================================= */

    .legal-bottom {
        max-width: 1200px;

        margin: 0 auto;

        padding: 22px 30px;

        display: flex;

        align-items: center;
        justify-content: space-between;

        border-top: 1px solid #e5e8eb;
    }

    .copyright {
        margin: 0;

        font-size: 12px;

        color: #687586;
    }

    .legal-badges {
        display: flex;

        align-items: center;

        gap: 18px;
    }

    .legal-badges img {
        display: block;

        width: 30px;
        height: auto;
    }


    /* =================================
       MOBILE
    ================================= */

    @media screen and (max-width: 768px) {

        .legal-authority {
            grid-template-columns: 1fr;
        }

        .legal-authority-item + .legal-authority-item {
            border-left: none;
            border-top: 1px solid #e5e8eb;
        }

        .insured-attention {
            padding: 40px 20px;
        }

        .attention-contacts {
            grid-template-columns: 1fr;
        }

        .legal-bottom {
            flex-direction: column;

            gap: 20px;

            text-align: center;
        }

    }

`;


export default function Legals() {

    return (

        <Div>

            {/* ================================
                SSN / ORGANISMO DE CONTROL
            ================================= */}

            <section className="legal-authority">

                <div className="legal-authority-item">
                    <p>
                        <strong>N.º de inscripción en SSN</strong>
                        0080
                    </p>
                </div>

                <div className="legal-authority-item">
                    <p>
                        <strong>Organismo de control</strong>
                        www.argentina.gob.ar/ssn
                    </p>
                </div>

                <div className="legal-authority-item">
                    <img
                        src={SSN}
                        alt="Superintendencia de Seguros de la Nación"
                    />
                </div>

            </section>


            {/* ================================
                ATENCIÓN AL ASEGURADO
            ================================= */}

            <section className="insured-attention">

                <div className="attention-header">

                    <span>Información al asegurado</span>

                    <h3>
                        Atención al asegurado
                    </h3>

                    <div className="attention-line"></div>

                </div>


                {/* Horario */}

                <div className="attention-schedule">

                    <p>
                        <strong>Horario de atención:</strong>{' '}
                        Lunes a Viernes de 10:00 hs a 17:00 hs
                    </p>

                </div>


                {/* Descripción */}

                <p className="attention-description">

                    La entidad aseguradora dispone de un Servicio de
                    Atención al Asegurado que atenderá las consultas y
                    reclamos que presenten los tomadores de seguros,
                    asegurados, beneficiarios y/o derechohabientes.
                    El servicio de Atención al Asegurado está integrado por:

                </p>


                {/* Contactos */}

                <div className="attention-contacts">

                    <div className="attention-contact">

                        <strong>
                            RESPONSABLE
                        </strong>

                        <p>
                            Moumdjian Natalia
                            <br />
                            Int. 3203
                            <br />
                            <a href="mailto:moumdjian.n@edificarseguros.com.ar">
                                moumdjian.n@edificarseguros.com.ar
                            </a>
                        </p>

                    </div>


                    <div className="attention-contact">

                        <strong>
                            SUPLENTE
                        </strong>

                        <p>
                            Débora Meijide
                            <br />
                            Int. 2127
                            <br />
                            <a href="mailto:meijide.d@edificarseguros.com.ar">
                                meijide.d@edificarseguros.com.ar
                            </a>
                        </p>

                    </div>

                </div>


                {/* Información SSN */}

                <div className="attention-footer">

                    <p>
                        <strong>
                            N.º DE INSCRIPCIÓN DE LA COMPAÑÍA ANTE LA SSN:
                        </strong>{' '}
                        0080
                    </p>

                    <p>
                        En caso de reclamo ante la entidad aseguradora no
                        resuelto o desestimado, podrá denunciarlo a través de{' '}
                        <a
                            href="https://www.argentina.gob.ar/ssn"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            www.argentina.gob.ar/ssn
                        </a>
                    </p>

                </div>

            </section>


            {/* ================================
                COPYRIGHT
            ================================= */}

            <section className="legal-bottom">

                <p className="copyright">
                    {/* EDIFICAR SEGUROS S.A. © 2017-2026
                    Todos los derechos reservados */}
                    EDIFICAR SEGUROS S.A. © 2017-{new Date().getFullYear()} Todos los derechos reservados
                </p>


                <div className="legal-badges">

                    <a
                        href="https://auth.afip.gob.ar/contribuyente_/login.xhtml?action=SYSTEM&system=denuncias"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            src={DataFiscal}
                            alt="Data Fiscal"
                        />
                    </a>

                    <ModalQr />

                </div>

            </section>

        </Div>
    );
}


// const Div = styled.div`

//     .img-grid {
//         justify-content: space-evenly;
//         display: grid;
//         grid-template-columns: 1fr 1fr;
//         align-items: center;
//         justify-items: center;
//     }

//     #bottom {
//         display: grid;
//         grid-template-columns: 8fr 1fr
//     }

//     #bottom img {
//         padding-left: 1.5px;
//     }

//     .Legals {
//         display: grid;
//         grid-template-columns: repeat(3, 1fr)
//     }
//     .Legals div {
//         height:100%;
//     }
//     .Legals p {
//         margin: 0px;
//         line-height: 1.2;
//         height: 100%;
//         display: grid;
//         align-content: center;
//         color: #000000cc;
//     }

//     section p {
//         font-size: 12px;
//     }

//     @media screen and (max-width: 996px) {

//         #bottom {
//             display: grid;
//             grid-template-columns: 1fr
//         }
        
//         section p {
//             font-size: 12px;
//             padding: 5px;
//         }
//         .Legals {
//             grid-template-columns: 1fr;
//             grid-gap: 20px;
//         }
//         .Legals div {
//             border: 0 !important
//         }
//     }



// `

// export default function Legals()  {

//     return(

//         <Div>
//             <section className="Legals text-center pb-2 pb-lg-5 pt-2 ">
//                 <div>
//                     <p>N° de inscripción en SSN<br/>0080 </p>
//                 </div>
//                 <div className="border-left">
//                     <p>Organismo de control <br/> www.argentina.gob.ar/ssn </p>
//                 </div>
//                 <div className="border-left">
//                     <img src={SSN} width="200px" alt=""/>
//                 </div>
//             </section>

//             <section className="pl-3 text-lg-left text-center">

//                 <p>Horario de atención, Lunes a Viernes de 10:00 hs a 17:00 hs</p>
//                 <p>La entidad aseguradora dispone de un Servicio de Atención al Asegurado que atenderá las consultas y reclamos que presenten los tomadores de seguros, asegurados, beneficiarios y/o derechohabientes.El servicio de Atención al Asegurado está integrado por:</p>
//                 <p><strong>RESPONSABLE:</strong> Moumdjian Natalia / Int 3203 / Mail: moumdjian.n@edificarseguros.com.ar</p>
//                 <p><strong>SUPLENTE:</strong> Débora Meijide / Int 2127 / Mail: meijide.d@edificarseguros.com.ar </p>
//                 <p>Nº DE INSCRIPCIÓN DE LA COMPAÑÍA ANTE LA SSN: 0080</p> 
//                 <p>En caso de reclamo ante la entidad aseguradora no resuelto o desestimado, podrá denunciarlo a través de  <a href="https://www.argentina.gob.ar/ssn" target="_F960AFIPInfo" rel="noopener noreferrer">www.argentina.gob.ar/ssn</a></p>

//             </section>


//             <section id="bottom" className="py-5 mb-5">
//                 <p className="pl-3 text-center text-md-left m-0" style={{ alignSelf: 'center' }}>EDIFICAR SEGUROS S.A. © 2017-2026 Todos los derechos reservados</p>
//                 <div className="img-grid">

//                     <a href="https://auth.afip.gob.ar/contribuyente_/login.xhtml?action=SYSTEM&system=denuncias" target="_F960AFIPInfo"><img src={DataFiscal} width="30px" /></a>

//                     <ModalQr />

//                 </div>
//             </section>



//         </Div>

//     )


// }